/*
 * This is to be a base store class for managing the shared state of a form, validation and error messages
 *
 * The base store accepts an observable mobx store and can react to changes there, providing a separate place
 * to store and manage what is form state and not muddy up the original store with a bunch of additional properties.
 *
 */
import {observable, action} from 'mobx';

/**
 * A base class for forms using mobx.
 *
 * Events:
 * validated: on whole-form validation completed.
 *   details: valid: boolean
 */
export class FormStore {
  /**
   * if the form is currently being saved (async request to the server)
   * @type {{saving: boolean, validated: boolean, error: null, fields: {}}}
   */
  @observable accessor formStatus = {
    saving: false,
    error: null,
    validated: false,
    fields: {},
  };

  /**
   * run validation for all fields
   */
  @action
  validateAll = () => {
    let valid = true;
    this.formStatus.error = null; // clear form error
    for (const key of Object.keys(this.formStatus.fields)) {
      const field = this.formStatus.fields[key];
      const isFieldValid = field.validate();
      if (!isFieldValid) window.evite && console.error(`field ${field.name} failed validation`);
      valid = isFieldValid && valid;
    }

    this.validated = true;
    return valid;
  };

  /**
   * true if the form is valid
   */
  get isValid() {
    if (!this.formStatus.validated) return false;
    if (this.formStatus.error) return false;
    for (const key of Object.keys(this.formStatus.fields)) {
      const component = this.formStatus.fields[key];
      if (component.isValid() === false) {
        evite.info(`component "${component.props.name}" is not valid`);
        return false;
      }
    }
    return true;
  }

  @action
  setFormError(message) {
    this.formStatus.error = message;
    // trigger event so others know of the error
    // this.dispatchEvent(new CustomEvent('validated', {detail: {valid: false}}));
  }
}
